exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".locale-selector .select-list.select-list--open{width:25vw;background:#fff;color:#434343;display:flex;flex-direction:column;justify-content:center;align-items:center;box-shadow:0 4px 10px rgba(0,0,0,.25)}", ""]);

// exports
